export default [
  {
    "項次": 1,
    "年度": "107/03~108/06",
    "工程種類1": "小區測漏",
    "工程種類2": "管線調查",
    "工程種類3": "換表相關",
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "義竹所分區計量委外管網建置及漏水調查作業",
    "標案金額": "42,920,000",
    "地點": "嘉義縣",
    "詳細範圍": "嘉義縣義竹鄉、鹿草鄉、東石鄉、布袋鎮等沿海四鄉鎮，義竹鄉23村，東石鄉24村，布袋鎮23里，鹿草鄉15村 等85村里",
    "備註": null
  },
  {
    "項次": 2,
    "年度": "107/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": "政府機構",
    "單位種類3": null,
    "主辦單位": "國統國際(股)公司",
    "標案名稱": "北投貴子坑溪2000mm自來水管線測漏工程",
    "標案金額": "20,000",
    "地點": "台北市",
    "詳細範圍": "台北市北投貴子坑溪",
    "備註": null
  },
  {
    "項次": 3,
    "年度": "106/09~107/10",
    "工程種類1": "小區測漏",
    "工程種類2": "管線調查",
    "工程種類3": "換表相關",
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "東勢營運所分區管網建置及漏水調查",
    "標案金額": "43,280,000",
    "地點": "台中市",
    "詳細範圍": "臺中市東勢區",
    "備註": null
  },
  {
    "項次": 4,
    "年度": "106/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "高雄三民家商",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "94,500",
    "地點": "高雄市",
    "詳細範圍": "高雄市左營區裕誠路1102號",
    "備註": null
  },
  {
    "項次": 5,
    "年度": "106/02",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "鴻立鋼鐵(股)公司",
    "標案名稱": "消防管線測漏工程",
    "標案金額": "52,500",
    "地點": "高雄市",
    "詳細範圍": "高雄市小港區沿海三路24號",
    "備註": null
  },
  {
    "項次": 6,
    "年度": "106/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "國立海洋生物博物館",
    "標案名稱": "消防管線測漏工程",
    "標案金額": "99,750",
    "地點": "屏東縣",
    "詳細範圍": "屏東縣車城鄉後灣村後灣路2號",
    "備註": null
  },
  {
    "項次": 7,
    "年度": "106/08",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣納美仕(股)公司",
    "標案名稱": "消防管線測漏工程",
    "標案金額": "70,000",
    "地點": "苗栗縣",
    "詳細範圍": "苗栗縣銅鑼鄉九湖村銅科一路3號",
    "備註": null
  },
  {
    "項次": 8,
    "年度": "106/09",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北市立動物園",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "84,588",
    "地點": "台北市",
    "詳細範圍": "臺北市文山區新光路二段30號",
    "備註": null
  },
  {
    "項次": 9,
    "年度": "106/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "聯華電子(股)公司",
    "標案名稱": "消防管線測漏工程",
    "標案金額": "47,250",
    "地點": "新竹市",
    "詳細範圍": "新竹市新竹科學園區力行二路3號",
    "備註": null
  },
  {
    "項次": 10,
    "年度": "106/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "安威資能科技(股)公司",
    "標案名稱": "消防管線測漏工程",
    "標案金額": "82,552",
    "地點": "台東縣",
    "詳細範圍": "台東縣綠島",
    "備註": null
  },
  {
    "項次": 11,
    "年度": "106/07~108/12",
    "工程種類1": "小區測漏",
    "工程種類2": "管線調查",
    "工程種類3": "換表相關",
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北自來水事業處",
    "標案名稱": "106-108年管網防漏控制與小區規劃計量整合作業",
    "標案金額": "33,807,875",
    "地點": "台北市",
    "詳細範圍": "台北市與新北市三重、新店、\n中和、永和區與汐止7個里",
    "備註": null
  },
  {
    "項次": 12,
    "年度": "106/07~106/12",
    "工程種類1": "小區測漏",
    "工程種類2": "管線調查",
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "106年度員林所計畫性漏水檢測委外作業",
    "標案金額": "6,669,600",
    "地點": "彰化縣",
    "詳細範圍": "彰化縣員林鎮、大村鄉",
    "備註": null
  },
  {
    "項次": 13,
    "年度": "106/3~107/12",
    "工程種類1": "小區測漏",
    "工程種類2": "管線調查",
    "工程種類3": "換表相關",
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "宜蘭縣溪南分區計量管網委外建置暨漏水調查作業",
    "標案金額": "33,500,000",
    "地點": "宜蘭縣",
    "詳細範圍": "宜蘭縣蘇澳鎮",
    "備註": null
  },
  {
    "項次": 14,
    "年度": "106/9",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": "政府機構",
    "單位種類3": null,
    "主辦單位": "良企機電顧問(股)公司",
    "標案名稱": "高鐵新竹六家基地測漏工程",
    "標案金額": "71,000",
    "地點": "新竹市",
    "詳細範圍": "新竹縣竹北市頭前溪北側之河川浮覆地上",
    "備註": null
  },
  {
    "項次": 15,
    "年度": "106/9",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台英帝國菸草製造(股)公司",
    "標案名稱": "消防管線測漏工程",
    "標案金額": "71,400",
    "地點": "苗栗縣",
    "詳細範圍": "苗栗縣竹南鎮群義路8號(廣源科技園區)",
    "備註": null
  },
  {
    "項次": 16,
    "年度": "105/09",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": "政府機構",
    "單位種類3": null,
    "主辦單位": "保固國際(股)公司",
    "標案名稱": "汐止東勢街自來水管線測漏工程",
    "標案金額": "36,750",
    "地點": "新北市",
    "詳細範圍": "新北市汐止區東勢街",
    "備註": null
  },
  {
    "項次": 17,
    "年度": "105/08",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "新北市環遊郡社區",
    "標案名稱": "第二次自來水管線測漏工程",
    "標案金額": "50,000",
    "地點": "新北市",
    "詳細範圍": "新北市淡水區環遊郡社區",
    "備註": null
  },
  {
    "項次": 18,
    "年度": "105/07",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北國際航空站",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "99,750",
    "地點": "台北市",
    "詳細範圍": "臺北國際航空站 10548 臺北市松山區敦化北路340之9號",
    "備註": null
  },
  {
    "項次": 19,
    "年度": "105/06",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "明宸環保科技有限公司",
    "標案名稱": "台灣美光消防管線測漏工程",
    "標案金額": "47,250",
    "地點": "台中市",
    "詳細範圍": "台中市后里區三豐路4段369號",
    "備註": null
  },
  {
    "項次": 20,
    "年度": "105/04",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "澎湖縣老人之家",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "63,000",
    "地點": "澎湖縣",
    "詳細範圍": "澎湖縣馬公市光華里123號",
    "備註": null
  },
  {
    "項次": 21,
    "年度": "105/05",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "新北市環遊郡社區",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "50,000",
    "地點": "新北市",
    "詳細範圍": "新北市淡水區環遊郡社區",
    "備註": null
  },
  {
    "項次": 22,
    "年度": "105/04",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": "政府機構",
    "單位種類3": null,
    "主辦單位": "賽昇科技有限公司",
    "標案名稱": "高鐵燕巢機廠測漏工程",
    "標案金額": "60,000",
    "地點": "高雄市",
    "詳細範圍": "高雄市燕巢區",
    "備註": null
  },
  {
    "項次": 23,
    "年度": "105/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "森霸電力(股)公司",
    "標案名稱": "消防管路測漏工程",
    "標案金額": "89,250",
    "地點": "台南市",
    "詳細範圍": "臺南市山上區豐德村隙子口66號",
    "備註": null
  },
  {
    "項次": 24,
    "年度": "105/04",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北市清江國小",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "26,500",
    "地點": "台北市",
    "詳細範圍": "台北市北投區奇岩里公館路220號",
    "備註": null
  },
  {
    "項次": 25,
    "年度": "105/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "新北市泰山高中",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "36,750",
    "地點": "新北市",
    "詳細範圍": "新北市泰山區辭修路7號",
    "備註": null
  },
  {
    "項次": 26,
    "年度": "105/02",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "森霸電力(股)公司",
    "標案名稱": "消防管路測漏工程",
    "標案金額": "89,250",
    "地點": "台南市",
    "詳細範圍": "臺南市山上區豐德村隙子口66號",
    "備註": null
  },
  {
    "項次": 27,
    "年度": "105/01~105/11",
    "工程種類1": "小區測漏",
    "工程種類2": "管線調查",
    "工程種類3": "換表相關",
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北自來水事業處",
    "標案名稱": "105年主動漏水控制委外作業",
    "標案金額": "9,003,325",
    "地點": "台北市",
    "詳細範圍": "台北市與新北市三重、新店、\n中和、永和區與汐止7個里",
    "備註": null
  },
  {
    "項次": 28,
    "年度": "105/01",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "永豐紙業(股)公司",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "22,500",
    "地點": "新北市",
    "詳細範圍": "新北市板橋區",
    "備註": "同一案"
  },
  {
    "項次": 29,
    "年度": "105/01",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "沈氏藝術印刷(股)公司",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "22,500",
    "地點": "新北市",
    "詳細範圍": "新北市板橋區",
    "備註": null
  },
  {
    "項次": 30,
    "年度": "105/01",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "仲量聯行(股)公司",
    "標案名稱": "台灣應用材料消防管線測漏工程",
    "標案金額": "58,000",
    "地點": "新竹市",
    "詳細範圍": "新竹市新竹科學工業園區研發二路32號",
    "備註": null
  },
  {
    "項次": 31,
    "年度": "104/08~106/06",
    "工程種類1": "小區測漏",
    "工程種類2": "管線調查",
    "工程種類3": "換表相關",
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "霧峰區分區計量管網委外規劃與建置",
    "標案金額": "36,800,000",
    "地點": "台中市",
    "詳細範圍": "台中市霧峰區",
    "備註": null
  },
  {
    "項次": 32,
    "年度": "104/12",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "苗栗縣竹南國小",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "63,000",
    "地點": "苗栗縣",
    "詳細範圍": "苗栗縣竹南國小-苗栗縣竹南鎮中正路146號",
    "備註": null
  },
  {
    "項次": 33,
    "年度": "104/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "世界先進積體電路(股)公司",
    "標案名稱": "消防管線測漏工程",
    "標案金額": "42,000",
    "地點": "新竹市",
    "詳細範圍": "新竹市新竹科學工業園區新竹科學工業園區新竹縣園區三路123號",
    "備註": null
  },
  {
    "項次": 34,
    "年度": "104/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "海軍司令部",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "50,000",
    "地點": "台北市",
    "詳細範圍": "台北市中山區北安路305號",
    "備註": null
  },
  {
    "項次": 35,
    "年度": "104/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "龍全機電工程有限公司",
    "標案名稱": "山葉機車桃園廠自來水管線測漏工程",
    "標案金額": "20,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市中壢區中華路二段三號",
    "備註": null
  },
  {
    "項次": 36,
    "年度": "104/07",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台中酒廠",
    "標案名稱": "消防灑水系統測漏工程",
    "標案金額": "94,500",
    "地點": "台中市",
    "詳細範圍": "台中市西屯區工業區28路2號",
    "備註": null
  },
  {
    "項次": 37,
    "年度": "104/08",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "桃園市希望四季社區",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "63,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市龍潭區希望四季社區",
    "備註": null
  },
  {
    "項次": 38,
    "年度": "104/09",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "陸軍專科學校",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "94,500",
    "地點": "桃園市",
    "詳細範圍": "桃園市中壢區中堅里3鄰龍東路750號",
    "備註": null
  },
  {
    "項次": 39,
    "年度": "104/06",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣鐵路管理局",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "39,375",
    "地點": "新竹市",
    "詳細範圍": "新竹市榮光里中華路2段445號",
    "備註": null
  },
  {
    "項次": 40,
    "年度": "104/06",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "憲兵指揮部",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "89,250",
    "地點": "台北市",
    "詳細範圍": "台北市中山區民族東路17號",
    "備註": null
  },
  {
    "項次": 41,
    "年度": "104/04",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "漢翔航空工業(股)公司",
    "標案名稱": "翔園供水管路委託測漏工程",
    "標案金額": "94,000",
    "地點": "台中市",
    "詳細範圍": "臺中市西屯區漢翔路1號",
    "備註": null
  },
  {
    "項次": 42,
    "年度": "104/05",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "中華電信研究院",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "47,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市楊梅區電研路99號",
    "備註": null
  },
  {
    "項次": 43,
    "年度": "104/05",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣氣電共生(股)共生",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "84,000",
    "地點": "台南市",
    "詳細範圍": "臺南市官田區二鎮里工業西路28號",
    "備註": null
  },
  {
    "項次": 44,
    "年度": "104/04",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣三菱電梯(股)公司",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "49,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市龜山區舊路村振興路321號",
    "備註": null
  },
  {
    "項次": 45,
    "年度": "104/06",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "桃園市中央大學",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "84,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市中壢區中大路300號",
    "備註": null
  },
  {
    "項次": 46,
    "年度": "104/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "桃園市福鎮社區",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "21,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市中壢區福鎮社區",
    "備註": null
  },
  {
    "項次": 47,
    "年度": "104/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "明宸環保科技有限公",
    "標案名稱": "台灣美光記憶體(股)公司測漏工程",
    "標案金額": "47,250",
    "地點": "台中市",
    "詳細範圍": "台中市后里區三豐路4段369號",
    "備註": null
  },
  {
    "項次": 48,
    "年度": "104/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "鑫旺科技工程有限公司",
    "標案名稱": "威斯汀度假酒店測漏工程",
    "標案金額": "17,500",
    "地點": "桃園市",
    "詳細範圍": "桃園縣大溪日新路 166 號",
    "備註": null
  },
  {
    "項次": 49,
    "年度": "104/01~104/12",
    "工程種類1": "小區測漏",
    "工程種類2": "管線調查",
    "工程種類3": "換表相關",
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北自來水事業處",
    "標案名稱": "104年主動漏水控制委外作業",
    "標案金額": "9,789,073",
    "地點": "台北市",
    "詳細範圍": "台北市與新北市三重、新店、\n中和、永和區與汐止7個里",
    "備註": null
  },
  {
    "項次": 50,
    "年度": "103/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北市立動物園",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "87,780",
    "地點": "台北市",
    "詳細範圍": "臺北市文山區新光路二段30號",
    "備註": null
  },
  {
    "項次": 51,
    "年度": "103/12",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "新北市重陽國小",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "55,000",
    "地點": "新北市",
    "詳細範圍": "新北市三重區中正北路113號",
    "備註": null
  },
  {
    "項次": 52,
    "年度": "103/12",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "宜蘭縣蓬萊國小",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "30,000",
    "地點": "宜蘭縣",
    "詳細範圍": "宜蘭縣蘇澳鎮南強里南澳路85號",
    "備註": null
  },
  {
    "項次": 53,
    "年度": "103/09",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "國華高爾夫球場",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "12,000",
    "地點": "台北市",
    "詳細範圍": "新北市淡水區坪頂里23-1號",
    "備註": null
  },
  {
    "項次": 54,
    "年度": "103/09",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "環遊郡社區",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "50,000",
    "地點": "新北市",
    "詳細範圍": "新北市淡水區環遊郡社區",
    "備註": null
  },
  {
    "項次": 55,
    "年度": "103/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北市北投國小",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "57,750",
    "地點": "台北市",
    "詳細範圍": "臺北市北投區中央北路一段73號",
    "備註": null
  },
  {
    "項次": 56,
    "年度": "103/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "南帝化學工業(股)公司",
    "標案名稱": "消防管線測漏工程",
    "標案金額": "60,900",
    "地點": "台南市",
    "詳細範圍": "台南市東區中華東路一段398號",
    "備註": null
  },
  {
    "項次": 57,
    "年度": "103/09",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣德聯高科技(股)公司",
    "標案名稱": "消防管線測漏工程",
    "標案金額": "47,250",
    "地點": "桃園市",
    "詳細範圍": "桃園市觀音區成功路二段915號",
    "備註": null
  },
  {
    "項次": 58,
    "年度": "103/10~104/12",
    "工程種類1": "小區測漏",
    "工程種類2": "管線調查",
    "工程種類3": "換表相關",
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北自來水事業處",
    "標案名稱": "103-104年小區委外規劃與計量分析",
    "標案金額": "9,866,132",
    "地點": "台北市",
    "詳細範圍": "台北市與新北市三重、新店、\n中和、永和區與汐止7個里",
    "備註": null
  },
  {
    "項次": 59,
    "年度": "103/09",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "高雄市應用科大",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "84,000",
    "地點": "高雄市",
    "詳細範圍": "高雄市三民區建工路415號",
    "備註": null
  },
  {
    "項次": 60,
    "年度": "103/09",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "東方瑞士社區",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "10,000",
    "地點": "基隆市",
    "詳細範圍": "基隆市暖暖區碇內街東方瑞士社區",
    "備註": null
  },
  {
    "項次": 61,
    "年度": "103/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "瑋祥科技有限公司",
    "標案名稱": "后里美光廠消防管線測漏工程",
    "標案金額": "29,400",
    "地點": "台中市",
    "詳細範圍": "台中市后里區三豐路4段369號",
    "備註": null
  },
  {
    "項次": 62,
    "年度": "103/08",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "鼎旺機電有限公司",
    "標案名稱": "青山鎮測漏工程",
    "標案金額": "23,100",
    "地點": "新北市",
    "詳細範圍": "新北市新店區青山鎮社區",
    "備註": null
  },
  {
    "項次": 63,
    "年度": "103/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北市台灣大學",
    "標案名稱": "農業綜合館自來水管線測漏工程",
    "標案金額": "38,745",
    "地點": "台北市",
    "詳細範圍": "台北市大安區羅斯福路四段一號",
    "備註": null
  },
  {
    "項次": 64,
    "年度": "103/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北市台灣大學",
    "標案名稱": "農業化學系館自來水管線測漏工程",
    "標案金額": "77,000",
    "地點": "台北市",
    "詳細範圍": "台北市大安區羅斯福路四段一號",
    "備註": null
  },
  {
    "項次": 65,
    "年度": "103/08",
    "工程種類1": "小區測漏",
    "工程種類2": "管線調查",
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "中壢市公所",
    "標案名稱": "地下管線探測定位工程",
    "標案金額": "95,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市中壢區環北路380號",
    "備註": null
  },
  {
    "項次": 66,
    "年度": "103/06",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "高雄市科學博物館",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "47,250",
    "地點": "高雄市",
    "詳細範圍": "高雄市路竹區中山路1821號",
    "備註": null
  },
  {
    "項次": 67,
    "年度": "103/07",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "新竹縣忠信高中",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "34,000",
    "地點": "新竹縣",
    "詳細範圍": "新竹縣新豐鄉忠信街178號",
    "備註": null
  },
  {
    "項次": 68,
    "年度": "103/06",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "新北市聖心小學",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "75,000",
    "地點": "新北市",
    "詳細範圍": "新北市八里區龍米路一段261號",
    "備註": null
  },
  {
    "項次": 69,
    "年度": "103/05",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "高雄港務分公司",
    "標案名稱": "馬公管理處自來水管線測漏工程",
    "標案金額": "78,750",
    "地點": "澎湖縣",
    "詳細範圍": "澎湖縣馬公市臨海路36之1號",
    "備註": null
  },
  {
    "項次": 70,
    "年度": "103/06",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "帝竑工程有限公司",
    "標案名稱": "台灣康寧玻璃顯示(股)公司消防管線測漏工程",
    "標案金額": "84,000",
    "地點": "台南市",
    "詳細範圍": "台南市安南區海西里海環街229巷11弄2號1樓",
    "備註": null
  },
  {
    "項次": 71,
    "年度": "103/05",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "仲量聯行(股)公司",
    "標案名稱": "台灣應用材料(股)公司消防管線測漏工程",
    "標案金額": "52,500",
    "地點": "新竹市",
    "詳細範圍": "新竹市新竹科學工業園區研發二路32號",
    "備註": null
  },
  {
    "項次": 72,
    "年度": "103/04",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "新北市蘆洲國中",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "57,750",
    "地點": "新北市",
    "詳細範圍": "新北市蘆洲區中正路265號",
    "備註": null
  },
  {
    "項次": 73,
    "年度": "103/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "學田營造有限公司",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "10,500",
    "地點": "新北市",
    "詳細範圍": "新北市",
    "備註": null
  },
  {
    "項次": 74,
    "年度": "103/01",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "新普建設(股)公司",
    "標案名稱": "禾和社區自來水管線測漏工程",
    "標案金額": "130,000",
    "地點": "新北市",
    "詳細範圍": "新北市新店區禾和特區",
    "備註": null
  },
  {
    "項次": 75,
    "年度": "102/12",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "漢翔航空工業(股)公司",
    "標案名稱": "翔園供水管路委託測漏工程",
    "標案金額": "50,000",
    "地點": "台中市",
    "詳細範圍": "臺中市西屯區漢翔路1號",
    "備註": null
  },
  {
    "項次": 76,
    "年度": "102/12",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北大眾捷運(股)公司",
    "標案名稱": "消防管路測漏工程",
    "標案金額": "47,750",
    "地點": "台北市",
    "詳細範圍": "台北市北投區",
    "備註": null
  },
  {
    "項次": 77,
    "年度": "102/09",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "中和市鳳凰城社區",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "46,305",
    "地點": "新北市",
    "詳細範圍": "新北市中和市鳳凰城社區",
    "備註": null
  },
  {
    "項次": 78,
    "年度": "102/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "承磐建設開發(股)公司",
    "標案名稱": "華城特區測漏工程",
    "標案金額": "73,500",
    "地點": "新北市",
    "詳細範圍": "新北市新店區華城特區",
    "備註": null
  },
  {
    "項次": 79,
    "年度": "102/12",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北市龍門國中",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "10,500",
    "地點": "台北市",
    "詳細範圍": "臺北市大安區建國南路二段269號",
    "備註": null
  },
  {
    "項次": 80,
    "年度": "102/09",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "桃園縣開南大學",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "90,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市開南路1號",
    "備註": null
  },
  {
    "項次": 81,
    "年度": "102/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "順天堂台中廠",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "50,000",
    "地點": "台中市",
    "詳細範圍": "台中市工業區42路16號",
    "備註": null
  },
  {
    "項次": 82,
    "年度": "102/07",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "新北市新泰國中",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "53,500",
    "地點": "新北市",
    "詳細範圍": "新北市新莊區新泰路359號",
    "備註": null
  },
  {
    "項次": 83,
    "年度": "102/06",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": " 桃園縣楊梅國中",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "42,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市楊梅區校前路149號",
    "備註": null
  },
  {
    "項次": 84,
    "年度": "102/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北市萬芳醫院",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "23,100",
    "地點": "台北市",
    "詳細範圍": "台北市文山區興隆路三段111號",
    "備註": null
  },
  {
    "項次": 85,
    "年度": "102/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "聯奇開發(股)公司",
    "標案名稱": "樹谷園區汙水管線測漏工程",
    "標案金額": "21,000",
    "地點": "台南市",
    "詳細範圍": "台南市新市區豐華村中心路8號",
    "備註": null
  },
  {
    "項次": 86,
    "年度": "102/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "大台北華城特區",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "126,000",
    "地點": "新北市",
    "詳細範圍": "新北市新店區華城特區",
    "備註": null
  },
  {
    "項次": 87,
    "年度": "102/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "新店區公所",
    "標案名稱": "屈尺社區自來水測漏工程",
    "標案金額": "95,000",
    "地點": "新北市",
    "詳細範圍": "新北市新店區屈尺社區",
    "備註": null
  },
  {
    "項次": 88,
    "年度": "101/12",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "新北市德霖專科",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "29,500",
    "地點": "新北市",
    "詳細範圍": "新北市土城區青雲路380巷1號",
    "備註": null
  },
  {
    "項次": 89,
    "年度": "101/12",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北市士東國小",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "25,000",
    "地點": "台北市",
    "詳細範圍": "臺北市士林區中山北路六段392號",
    "備註": null
  },
  {
    "項次": 90,
    "年度": "101/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "大台北華城聯合管委會",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "84,000",
    "地點": "新北市",
    "詳細範圍": "新北市新店區華城特區",
    "備註": null
  },
  {
    "項次": 91,
    "年度": "101/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "光音水電企業有限公司",
    "標案名稱": "英業達自來水管線測漏工程",
    "標案金額": "20,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市桃園區大智路88號",
    "備註": null
  },
  {
    "項次": 92,
    "年度": "101/11~102/12",
    "工程種類1": "小區測漏",
    "工程種類2": "管線調查",
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北自來水事業處",
    "標案名稱": "主動漏水控制委外作業",
    "標案金額": "19,591,395",
    "地點": "台北市",
    "詳細範圍": "台北市與新北市三重、新店、\n中和、永和區與汐止7個里",
    "備註": null
  },
  {
    "項次": 93,
    "年度": "101/9",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北市台北醫學大學",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "47,250",
    "地點": "台北市",
    "詳細範圍": "臺北市信義區吳興街250號",
    "備註": null
  },
  {
    "項次": 94,
    "年度": "101/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "桃園縣中原大學",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "78,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市中壢區中北路200號",
    "備註": null
  },
  {
    "項次": 95,
    "年度": "101/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "新北市德音國小",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "52,920",
    "地點": "新北市",
    "詳細範圍": "新北市五股區明德路２號",
    "備註": null
  },
  {
    "項次": 96,
    "年度": "101/07",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "桃園縣開南大學",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "94,500",
    "地點": "桃園市",
    "詳細範圍": "桃園市開南路1號",
    "備註": null
  },
  {
    "項次": 97,
    "年度": "101/07",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北市五常國小",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "50,000",
    "地點": "台北市",
    "詳細範圍": "台北市中山區五常街16號",
    "備註": null
  },
  {
    "項次": 98,
    "年度": "100/09",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "宜蘭縣耕莘專校",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "57,750",
    "地點": "宜蘭縣",
    "詳細範圍": "宜蘭縣三星鄉尚武村健富路二段407號",
    "備註": null
  },
  {
    "項次": 99,
    "年度": "101/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "桃園縣治平高中",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "10,500",
    "地點": "桃園市",
    "詳細範圍": "桃園市楊梅區中興路137號",
    "備註": null
  },
  {
    "項次": 100,
    "年度": "101/04",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "新北市景文科大",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "75,000",
    "地點": "新北市",
    "詳細範圍": "新北市新店區安忠路99號",
    "備註": null
  },
  {
    "項次": 101,
    "年度": "101/04",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北市幸安國小",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "62,606",
    "地點": "台北市",
    "詳細範圍": "臺北市大安區仁愛路三段22號 ",
    "備註": null
  },
  {
    "項次": 102,
    "年度": "101/04",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "桃園縣中壢高中",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "60,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市中壢區三光路115號",
    "備註": null
  },
  {
    "項次": 103,
    "年度": "101/02",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "苗栗縣竹南國小",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "59,063",
    "地點": "苗栗縣",
    "詳細範圍": "苗栗縣竹南鎮中正路146號",
    "備註": null
  },
  {
    "項次": 104,
    "年度": "101/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "高雄市海軍官校",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "22,050",
    "地點": "高雄市",
    "詳細範圍": "高雄市左營區軍校路669號",
    "備註": null
  },
  {
    "項次": 105,
    "年度": "101/05",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "基隆市綠葉山莊",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "119,700",
    "地點": "基隆市",
    "詳細範圍": "基隆市七堵區綠葉山莊社區",
    "備註": null
  },
  {
    "項次": 106,
    "年度": "101/09",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "大湖科學園區第三期管委會",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "13,333",
    "地點": "新北市",
    "詳細範圍": "新北市汐止區康寧街169巷21號",
    "備註": null
  },
  {
    "項次": 107,
    "年度": "101/08",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "承磐建設開發(股)公司",
    "標案名稱": "華城特區測漏工程",
    "標案金額": "80,000",
    "地點": "新北市",
    "詳細範圍": "新北市新店區華城特區",
    "備註": null
  },
  {
    "項次": 108,
    "年度": "101/09",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "遠翔建設事業(股)公司",
    "標案名稱": "三峽社區測漏工程",
    "標案金額": "16,666",
    "地點": "新北市",
    "詳細範圍": "新北市三峽區",
    "備註": null
  },
  {
    "項次": 109,
    "年度": "101/07",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "東森國際股份有限公司",
    "標案名稱": "楊梅社區測漏工程",
    "標案金額": "90,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市楊梅區",
    "備註": null
  },
  {
    "項次": 110,
    "年度": "101/12",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "聯奇開發股份有限公司",
    "標案名稱": "樹谷園區自來水測漏工程",
    "標案金額": "136,500",
    "地點": "台南市",
    "詳細範圍": "台南市新市區豐華村中心路8號",
    "備註": null
  },
  {
    "項次": 111,
    "年度": "101/05",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "輝瑞生技股份有限公司",
    "標案名稱": "消防管線測漏工程",
    "標案金額": "22,500",
    "地點": "新竹市",
    "詳細範圍": "新竹縣新豐鄉中崙村中崙290之1號",
    "備註": null
  },
  {
    "項次": 112,
    "年度": "101/06",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "交通部公路局南訓中心",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "99,750",
    "地點": "高雄市",
    "詳細範圍": "高雄市橋頭區里林東路公路巷 120 號",
    "備註": null
  },
  {
    "項次": 113,
    "年度": "101/02",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": "民營企業",
    "單位種類3": null,
    "主辦單位": "中國石油股份有限公司",
    "標案名稱": "台中港消防管測漏工程",
    "標案金額": "24,000",
    "地點": "台中市",
    "詳細範圍": "台中市梧棲區南堤路二段88號",
    "備註": null
  },
  {
    "項次": 114,
    "年度": "101/02",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": "民營企業",
    "單位種類3": null,
    "主辦單位": "中國石油股份有限公司",
    "標案名稱": "基隆儲運處測漏工程",
    "標案金額": "90,000",
    "地點": "基隆市",
    "詳細範圍": "基隆市七堵區八德路2-15號",
    "備註": null
  },
  {
    "項次": 115,
    "年度": "100/12",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": "民營企業",
    "單位種類3": null,
    "主辦單位": "財團法人台灣產業服務基金會",
    "標案名稱": "新北市實踐國小測漏工程",
    "標案金額": "10,000",
    "地點": "新北市",
    "詳細範圍": "新北市板橋區實踐路93巷51號",
    "備註": null
  },
  {
    "項次": 116,
    "年度": "100/11",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": "民營企業",
    "單位種類3": null,
    "主辦單位": "財團法人台灣產業服務基金會",
    "標案名稱": "雲林縣雲林國中測漏工程",
    "標案金額": "78,750",
    "地點": "雲林縣",
    "詳細範圍": "雲林縣斗六市明德路599號",
    "備註": null
  },
  {
    "項次": 117,
    "年度": "100/11",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": "民營企業",
    "單位種類3": null,
    "主辦單位": "財團法人台灣產業服務基金會",
    "標案名稱": "台南市復興國中測漏工程",
    "標案金額": "78,750",
    "地點": "台南市",
    "詳細範圍": "台南市東區裕文路62號",
    "備註": null
  },
  {
    "項次": 118,
    "年度": "100/11",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": "民營企業",
    "單位種類3": null,
    "主辦單位": "財團法人台灣產業服務基金會",
    "標案名稱": "雲林縣崙背國中測漏工程",
    "標案金額": "78,750",
    "地點": "雲林縣",
    "詳細範圍": "雲林縣崙背鄉大成路91號",
    "備註": null
  },
  {
    "項次": 119,
    "年度": "100/11",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": "民營企業",
    "單位種類3": null,
    "主辦單位": "財團法人台灣產業服務基金會",
    "標案名稱": "台中市太平國中測漏工程",
    "標案金額": "78,750",
    "地點": "台中市",
    "詳細範圍": "台中市太平區中山路二段116號",
    "備註": null
  },
  {
    "項次": 120,
    "年度": "100/11",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": "民營企業",
    "單位種類3": null,
    "主辦單位": "財團法人台灣產業服務基金會",
    "標案名稱": "台中市岸理國小測漏工程",
    "標案金額": "78,750",
    "地點": "台中市",
    "詳細範圍": "台中市神岡區中山路52號",
    "備註": null
  },
  {
    "項次": 121,
    "年度": "100/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "鳳凰城公寓大廈管委會",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "21,000",
    "地點": "新北市",
    "詳細範圍": "新北市中和區鳳凰城社區",
    "備註": null
  },
  {
    "項次": 122,
    "年度": "100/09",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "漢翔航空工業(股)公司",
    "標案名稱": "翔園供水管路委託測漏工程",
    "標案金額": "93,000",
    "地點": "台中市",
    "詳細範圍": "臺中市西屯區漢翔路1號",
    "備註": null
  },
  {
    "項次": 123,
    "年度": "100/08",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "日商鹿島營造(股)公司",
    "標案名稱": "蘆洲捷運機廠測漏工程",
    "標案金額": "21,000",
    "地點": "新北市",
    "詳細範圍": "新北市蘆洲區環堤大道698號",
    "備註": null
  },
  {
    "項次": 124,
    "年度": "100/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "東森國際(股)公司",
    "標案名稱": "楊梅溫泉社區管線測漏工程",
    "標案金額": "73,500",
    "地點": "桃園市",
    "詳細範圍": "桃園市楊梅區東森路3號",
    "備註": null
  },
  {
    "項次": 125,
    "年度": "100/08",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "漢翔航空工業(股)公司",
    "標案名稱": "翔園供水管路委託測漏工程",
    "標案金額": "48,000",
    "地點": "台中市",
    "詳細範圍": "臺中市西屯區漢翔路1號",
    "備註": null
  },
  {
    "項次": 126,
    "年度": "100/07",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "大譽實業有限公司",
    "標案名稱": "南竿消防水管測漏工程",
    "標案金額": "42,000",
    "地點": "馬祖縣",
    "詳細範圍": "馬袓縣南竿鄉",
    "備註": null
  },
  {
    "項次": 127,
    "年度": "100/09",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "新竹市殯葬管理所",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "13,125",
    "地點": "新竹市",
    "詳細範圍": "新竹市北區成德路132號",
    "備註": null
  },
  {
    "項次": 128,
    "年度": "99/05",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "東煌工程(股)公司",
    "標案名稱": "三峽遠雄建設自來水管線測漏工程",
    "標案金額": "80,000",
    "地點": "新北市",
    "詳細範圍": "新北市三峽區",
    "備註": null
  },
  {
    "項次": 129,
    "年度": "99/02",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "學校單位",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "旗美高中",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "42,000",
    "地點": "高雄市",
    "詳細範圍": "高雄市旗山區樹人路21號",
    "備註": null
  },
  {
    "項次": 130,
    "年度": "99/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "交通部觀光局東北角暨宜蘭管理處",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "94,500",
    "地點": "宜蘭縣",
    "詳細範圍": "宜蘭縣頭城鎮頭城鎮港墘路60號",
    "備註": null
  },
  {
    "項次": 131,
    "年度": "99/02",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "東森國際(股)公司",
    "標案名稱": "楊梅溫泉社區管線測漏工程",
    "標案金額": "21,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市楊梅區東森路3號",
    "備註": null
  },
  {
    "項次": 132,
    "年度": "99/02",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "大陸工程(股)公司",
    "標案名稱": "新莊機廠地下管線測漏工程",
    "標案金額": "10,000",
    "地點": "新北市",
    "詳細範圍": "新北市新莊區中正路746巷1號",
    "備註": null
  },
  {
    "項次": 133,
    "年度": "98/11",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "京電工程(股)公司",
    "標案名稱": "林口法國小鎮管線測漏工程",
    "標案金額": "21,000",
    "地點": "新北市",
    "詳細範圍": "新北市林口區法國小鎮社區",
    "備註": null
  },
  {
    "項次": 134,
    "年度": "98/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "漢翔航空工業(股)公司",
    "標案名稱": "沙鹿廠區供水管路測漏工程",
    "標案金額": "38,000",
    "地點": "台中市",
    "詳細範圍": "臺中市沙鹿區中清路六段366號",
    "備註": null
  },
  {
    "項次": 135,
    "年度": "98/09",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "世界先進積體電路(股)公司",
    "標案名稱": "一廠消防管線測漏工程",
    "標案金額": "57,750",
    "地點": "新竹市",
    "詳細範圍": "新竹縣寶山鄉園區三路123號",
    "備註": null
  },
  {
    "項次": 136,
    "年度": "98/10",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "世界先進積體電路(股)公司",
    "標案名稱": "二廠消防管線測漏工程",
    "標案金額": "95,550",
    "地點": "新竹市",
    "詳細範圍": "新竹市東區新竹市東區力行路9號",
    "備註": null
  },
  {
    "項次": 137,
    "年度": "98/08",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "漢翔航空工業(股)公司",
    "標案名稱": "翔園供水管路委託測漏工程",
    "標案金額": "51,450",
    "地點": "台中市",
    "詳細範圍": "臺中市西屯區漢翔路1號",
    "備註": null
  },
  {
    "項次": 138,
    "年度": "98/08",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "東森國際(股)公司",
    "標案名稱": "『麗城山莊』測漏工程",
    "標案金額": "73,500",
    "地點": "桃園市",
    "詳細範圍": "桃園市麗城山莊",
    "備註": null
  },
  {
    "項次": 139,
    "年度": "98/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "國防部陸軍步兵學校",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "99,750",
    "地點": "高雄市",
    "詳細範圍": "高雄市鳳山區維武路1號",
    "備註": null
  },
  {
    "項次": 140,
    "年度": "97/11",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "秉陽營造有限公司",
    "標案名稱": "台積電12廠消防管線測漏工程",
    "標案金額": "33,296",
    "地點": "新竹市",
    "詳細範圍": "新竹縣寶山鄉園區二路188號",
    "備註": null
  },
  {
    "項次": 141,
    "年度": "97/12",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "聯華電子(股)公司",
    "標案名稱": "8S一期消防管線測漏工程",
    "標案金額": "38,850",
    "地點": "新竹市",
    "詳細範圍": "新竹縣寶山鄉研新一路16號",
    "備註": null
  },
  {
    "項次": 142,
    "年度": "97/07~97/08",
    "工程種類1": "小區測漏",
    "工程種類2": "管線調查",
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台肥公司花蓮廠",
    "標案名稱": "地下管線測漏及GPS定位工程",
    "標案金額": "370,000",
    "地點": "花蓮縣",
    "詳細範圍": "花蓮縣花蓮市花蓮市華東15號",
    "備註": null
  },
  {
    "項次": 143,
    "年度": "97/09",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北內湖花市",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "25,200",
    "地點": "台北市",
    "詳細範圍": "台北市內湖區",
    "備註": null
  },
  {
    "項次": 144,
    "年度": "97/03",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台中菩提仁愛之家",
    "標案名稱": "自來水管線測漏工程",
    "標案金額": "24,999",
    "地點": "台北市",
    "詳細範圍": "台中市大里區大明路55號",
    "備註": null
  },
  {
    "項次": 145,
    "年度": "96/05",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "漢翔航空工業(股)公司",
    "標案名稱": "台中土木工廠管路測漏工程",
    "標案金額": "70,000",
    "地點": "台中市",
    "詳細範圍": "臺中市西屯區漢翔路1號",
    "備註": null
  },
  {
    "項次": 146,
    "年度": "96/07",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "漢翔航空工業(股)公司",
    "標案名稱": "台中雲漢大樓管路測漏工程",
    "標案金額": "66,000",
    "地點": "台中市",
    "詳細範圍": "臺中市西屯區漢翔路1號",
    "備註": null
  },
  {
    "項次": 147,
    "年度": "95/05",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "新店市公所",
    "標案名稱": "達觀里自來水漏水檢測工程",
    "標案金額": "89,897",
    "地點": "新北市",
    "詳細範圍": "新北市新店區",
    "備註": null
  },
  {
    "項次": 148,
    "年度": "95/11~95/12",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "行政院核能研究所",
    "標案名稱": "供水管路測漏工程",
    "標案金額": "315,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市龍潭區文化路1000號",
    "備註": null
  },
  {
    "項次": 149,
    "年度": "95/12",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "漢翔航空工業(股)公司",
    "標案名稱": "台中廠區供水管路測漏工程",
    "標案金額": "35,000",
    "地點": "台中市",
    "詳細範圍": "臺中市西屯區漢翔路1號",
    "備註": null
  },
  {
    "項次": 150,
    "年度": "94/06~94/07",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "漢翔航空工業(股)公司",
    "標案名稱": "翔陽及沙北廠區測漏工程",
    "標案金額": "560,323",
    "地點": "台中市",
    "詳細範圍": "臺中市沙鹿區中清路六段366號",
    "備註": null
  },
  {
    "項次": 151,
    "年度": "95/11",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "漢翔航空工業(股)公司",
    "標案名稱": "沙鹿廠區供水管路測漏工程",
    "標案金額": "85,000",
    "地點": "台中市",
    "詳細範圍": "臺中市沙鹿區中清路六段366號",
    "備註": null
  },
  {
    "項次": 152,
    "年度": "94/11",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "漢翔航空工業(股)公司",
    "標案名稱": "二指部供水管線測漏工程",
    "標案金額": "80,000",
    "地點": "台中市",
    "詳細範圍": "臺中市西屯區漢翔路1號",
    "備註": null
  },
  {
    "項次": 153,
    "年度": "95/07",
    "工程種類1": "小區測漏",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "漢翔航空工業(股)公司",
    "標案名稱": "沙北廠區供水管線緊急測漏工程",
    "標案金額": "85,000",
    "地點": "台中市",
    "詳細範圍": "臺中市沙鹿區中清路六段366號",
    "備註": null
  },
  {
    "項次": 154,
    "年度": "106/03~106/04",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "竹科園區三路1350mm免開挖探管工程",
    "標案金額": "730,000",
    "地點": "新竹市",
    "詳細範圍": "新竹市竹科園區三路",
    "備註": null
  },
  {
    "項次": 155,
    "年度": "106/06",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": "政府機構",
    "單位種類3": null,
    "主辦單位": "新野科技(股)公司",
    "標案名稱": "台灣中油公司新竹廠探管工程",
    "標案金額": "42,000",
    "地點": "新竹市",
    "詳細範圍": "新竹市竹科園區",
    "備註": null
  },
  {
    "項次": 156,
    "年度": "105/11~106/01",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "鯉魚潭廠至大安溪送水管探測及地質鑽探",
    "標案金額": "999,990",
    "地點": "苗栗縣",
    "詳細範圍": "苗栗縣三義鄉鯉魚潭村三櫃106號",
    "備註": null
  },
  {
    "項次": 157,
    "年度": "104/11",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北自來水事業處",
    "標案名稱": "地下管線探管定位工程",
    "標案金額": "89,250",
    "地點": "台北市",
    "詳細範圍": "台北市與新北市三重、新店、\n中和、永和區與汐止7個里",
    "備註": null
  },
  {
    "項次": 158,
    "年度": "104/11",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北市立動物園",
    "標案名稱": "地下管線探測工程",
    "標案金額": "24,833",
    "地點": "台北市",
    "詳細範圍": "臺北市文山區新光路二段30號",
    "備註": null
  },
  {
    "項次": 159,
    "年度": "102/07~102/08",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "中壢市公",
    "標案名稱": "中壢市102年地下管線非破壞性探測工程",
    "標案金額": "1,400,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市中壢區環北路380號",
    "備註": null
  },
  {
    "項次": 160,
    "年度": "101/07",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": "政府機構",
    "單位種類3": null,
    "主辦單位": "新野科技(股)公司",
    "標案名稱": "台北港地下管線探測工程",
    "標案金額": "42,000",
    "地點": "新北市",
    "詳細範圍": "新北市八里區",
    "備註": null
  },
  {
    "項次": 161,
    "年度": "101/08",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": "政府機構",
    "單位種類3": null,
    "主辦單位": "宗信土木大地技師事務所",
    "標案名稱": "台北捷運管線調查工程",
    "標案金額": "47,250",
    "地點": "台北市",
    "詳細範圍": "台北市",
    "備註": null
  },
  {
    "項次": 162,
    "年度": "101/05",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": "政府機構",
    "單位種類3": null,
    "主辦單位": "新野科技(股)公司",
    "標案名稱": "地下管線探測工程",
    "標案金額": "36,750",
    "地點": "桃園市",
    "詳細範圍": "桃園市",
    "備註": null
  },
  {
    "項次": 163,
    "年度": "101/05",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": "政府機構",
    "單位種類3": null,
    "主辦單位": "集美工程顧問(股)公司",
    "標案名稱": "配合桃園航空城區域計畫-免開挖探管工程",
    "標案金額": "315,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市桃園航空城",
    "備註": null
  },
  {
    "項次": 164,
    "年度": "100/11~100/12",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "香山送水管(A)(B)段探管工程",
    "標案金額": "849,000",
    "地點": "新竹市",
    "詳細範圍": "新竹市香山區",
    "備註": null
  },
  {
    "項次": 165,
    "年度": "100/05~100/07",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "香山送水管(一)-1探管工程",
    "標案金額": "658,560",
    "地點": "新竹市",
    "詳細範圍": "新竹市香山區",
    "備註": null
  },
  {
    "項次": 166,
    "年度": "100/08",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": "政府機構",
    "單位種類3": null,
    "主辦單位": "台灣世曦工程顧問(股)公司",
    "標案名稱": "湖山水庫探管工程",
    "標案金額": "276,410",
    "地點": "雲林縣",
    "詳細範圍": "雲林縣斗六市湖山里湖山水庫",
    "備註": null
  },
  {
    "項次": 167,
    "年度": "99/01~99/02",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "羅東堰計畫宜蘭送水管(二)探管工程",
    "標案金額": "89,250",
    "地點": "宜蘭縣",
    "詳細範圍": "宜蘭縣宜蘭市、羅東鎮",
    "備註": null
  },
  {
    "項次": 168,
    "年度": "99/01",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "福聚太陽能(股)公司",
    "標案名稱": "地下管線免開挖探管工程",
    "標案金額": "63,000",
    "地點": "桃園市",
    "詳細範圍": "桃園市",
    "備註": null
  },
  {
    "項次": 169,
    "年度": "97/06~97/11",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北自來水事業處",
    "標案名稱": "東區閥類覓測、清理及定位工程",
    "標案金額": "3,289,962",
    "地點": "台北市",
    "詳細範圍": "供水行政區：中山、松山、信義、南港、內湖、汐止。\n供水轄區範圍說明：\n1. 中山北路一段至三段單號建築線以東\n2. 八德路一段至基隆路單號建築物以北\n3. 基隆路一段至信義路五段單號、 建築線以東、 建築線以北\n4. 南港區、 內湖區及大直北安路\n5. 汐止區北山里、 環河里、 橫科里、 福山里、 宜興里、 忠山里、 東勢里",
    "備註":null
  },
  {
    "項次": 170,
    "年度": "97/06~97/11",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北自來水事業處",
    "標案名稱": "陽明閥類覓測、清理及定位工程",
    "標案金額": "2,999,798",
    "地點": "台北市",
    "詳細範圍": "北投、士林、石牌、天母\n1. 中山北路四段（劍潭青年活動中心起）（東）\n2. 百齡橋基隆河（ 通河東街） 以北（ 西南）\n3. 大度路三段、 中央北路四段聖景路路口省市交界（ 支援台灣自來水公司）（ 西北）\n4. 陽明山竹子湖路、 陽金公路、 竹子湖派出所鞍部（ 東北）",
    "備註":null
  },
  {
    "項次": 171,
    "年度": "99/01",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "民營企業",
    "單位種類2": "政府機構",
    "單位種類3": null,
    "主辦單位": "高堃營造有限公司",
    "標案名稱": "淡海新市鎮推進管線探管工程",
    "標案金額": "251,580",
    "地點": "新北市",
    "詳細範圍": "新北市淡水區",
    "備註": null
  },
  {
    "項次": 172,
    "年度": "98/02",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北自來水事業處",
    "標案名稱": "台北地區免開挖探管作業",
    "標案金額": "95,676",
    "地點": "台北市",
    "詳細範圍": "台北市與新北市三重、新店、\n中和、永和區與汐止7個里",
    "備註": null
  },
  {
    "項次": 173,
    "年度": "98/09~98/10",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "龍潭至平鎮至八德送水管(一)探管工程",
    "標案金額": "83,751",
    "地點": "桃園市",
    "詳細範圍": "桃園市龍潭區、平鎮區、八德區",
    "備註": null
  },
  {
    "項次": 174,
    "年度": "98/02~98/03",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "宜蘭送水管(四)探管工程",
    "標案金額": "285,138",
    "地點": "宜蘭縣",
    "詳細範圍": "宜蘭縣宜蘭市、羅東鎮",
    "備註": null
  },
  {
    "項次": 175,
    "年度": "98/06~98/06",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "宜蘭送水管(四)第二次探管工程",
    "標案金額": "82,662",
    "地點": "宜蘭縣",
    "詳細範圍": "宜蘭縣宜蘭市、羅東鎮",
    "備註": null
  },
  {
    "項次": 176,
    "年度": "98/03~98/05",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "板二計畫管線銜接探管工程",
    "標案金額": "2,201,576",
    "地點": "新北市",
    "詳細範圍": "新北市板橋區文化路",
    "備註": null
  },
  {
    "項次": 177,
    "年度": "97/07~97/08",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "羅東探管工程（五）",
    "標案金額": "859,000",
    "地點": "宜蘭縣",
    "詳細範圍": "宜蘭縣宜蘭市、羅東鎮",
    "備註": null
  },
  {
    "項次": 178,
    "年度": "97/11~97/12",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "竹北-新埔送水管2-1探管工程",
    "標案金額": "462,300",
    "地點": "新竹市",
    "詳細範圍": "新竹縣竹北市、新埔鎮",
    "備註": null
  },
  {
    "項次": 179,
    "年度": "96/10~96/11",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "淡海新市鎮區外送水管探管工程",
    "標案金額": "1,380,000",
    "地點": "新北市",
    "詳細範圍": "新北市淡水區",
    "備註": null
  },
  {
    "項次": 180,
    "年度": "96/06~96/07",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "羅東堰計畫-宜蘭、羅東探管工程",
    "標案金額": "870,219",
    "地點": "宜蘭縣",
    "詳細範圍": "宜蘭縣宜蘭市、羅東鎮",
    "備註": null
  },
  {
    "項次": 181,
    "年度": "96/09",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "三重市公所",
    "標案名稱": "正義南路與重安街等免開挖探管作業",
    "標案金額": "97,903",
    "地點": "新北市",
    "詳細範圍": "新北市三重區正義南路與重安街",
    "備註": null
  },
  {
    "項次": 182,
    "年度": "95/05~95/06",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "寶山三期擴建(七)探管工程",
    "標案金額": "490,323",
    "地點": "新竹市",
    "詳細範圍": "新竹縣寶山鄉",
    "備註": null
  },
  {
    "項次": 183,
    "年度": "95/08~95/09",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "羅東送水管(一)及管(二)探管工程",
    "標案金額": "630,000",
    "地點": "宜蘭縣",
    "詳細範圍": "宜蘭縣宜蘭市、羅東鎮",
    "備註": null
  },
  {
    "項次": 184,
    "年度": "94/04~94/06",
    "工程種類1": "管線調查",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台灣自來水(股)公司",
    "標案名稱": "寶山三期擴建(五)~(六)探管工程",
    "標案金額": "1,180,323",
    "地點": "新竹市",
    "詳細範圍": "新竹縣寶山鄉",
    "備註": null
  },
  {
    "項次": 185,
    "年度": "106/07~106/11",
    "工程種類1": "換表相關",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北自來水事業處",
    "標案名稱": "南區專案性換表工程",
    "標案金額": "4,141,311",
    "地點": "台北市",
    "詳細範圍": "大安、中正、信義、文山、新店\n1. 中山南路以東\n2. 忠孝東路一、 二段、 八德路一段至四段雙號、 信義路五段150巷以南\n3. 基隆路一、 二、 三、 四段以西\n4. 羅斯福路一至四段單號以東及羅斯福路五、 六段\n5. 新店區包括新店溪以東地區（ 安康地區除外）",
    "備註":null
  },
  {
    "項次": 186,
    "年度": "106/03~106/11",
    "工程種類1": "換表相關",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北自來水事業處",
    "標案名稱": "南區換表工程",
    "標案金額": "8,000,849",
    "地點": "台北市",
    "詳細範圍": "大安、中正、信義、文山、新店\n1. 中山南路以東\n2. 忠孝東路一、 二段、 八德路一段至四段雙號、 信義路五段150巷以南\n3. 基隆路一、 二、 三、 四段以西\n4. 羅斯福路一至四段單號以東及羅斯福路五、 六段\n5. 新店區包括新店溪以東地區（ 安康地區除外）",
    "備註":null
  },
  {
    "項次": 187,
    "年度": "105/01~105/11",
    "工程種類1": "換表相關",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北自來水事業處",
    "標案名稱": "北區換表工程",
    "標案金額": "4,120,700",
    "地點": "台北市",
    "詳細範圍": "大同、延平、社子、三重\n1. 臺北市中山北路1至3段道路中心線以西\n2. 臺北市忠孝西路1至2段道路中心線以北\n3. 臺北市社子地區四、 新北市三重區（ 不含二重疏洪道以西）",
    "備註":null
  },
  {
    "項次": 188,
    "年度": "104/01~104/11",
    "工程種類1": "換表相關",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北自來水事業處",
    "標案名稱": "陽明區換表作業",
    "標案金額": "2,884,796",
    "地點": "台北市",
    "詳細範圍": "北投、士林、石牌、天母\n1. 中山北路四段（劍潭青年活動中心起）（東）\n2. 百齡橋基隆河（ 通河東街） 以北（ 西南）\n3. 大度路三段、 中央北路四段聖景路路口省市交界（ 支援台灣自來水公司）（ 西北）\n4. 陽明山竹子湖路、 陽金公路、 竹子湖派出所鞍部（ 東北）",
    "備註":null
  },
  {
    "項次": 189,
    "年度": "103/02~103/11",
    "工程種類1": "換表相關",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北自來水事業處",
    "標案名稱": "東區換表作業",
    "標案金額": "6,137,496",
    "地點": "台北市",
    "詳細範圍": "供水行政區：中山、松山、信義、南港、內湖、汐止。\n供水轄區範圍說明：\n1. 中山北路一段至三段單號建築線以東\n2. 八德路一段至基隆路單號建築物以北\n3. 基隆路一段至信義路五段單號、 建築線以東、 建築線以北\n4. 南港區、 內湖區及大直北安路\n5. 汐止區北山里、 環河里、 橫科里、 福山里、 宜興里、 忠山里、 東勢里",
    "備註":null
  },
  {
    "項次": 190,
    "年度": "98/02~98/12",
    "工程種類1": "換表相關",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北自來水事業處",
    "標案名稱": "陽明區換表作業",
    "標案金額": "2,831,059",
    "地點": "台北市",
    "詳細範圍": "北投、士林、石牌、天母\n1. 中山北路四段（劍潭青年活動中心起）（東）\n2. 百齡橋基隆河（ 通河東街） 以北（ 西南）\n3. 大度路三段、 中央北路四段聖景路路口省市交界（ 支援台灣自來水公司）（ 西北）\n4. 陽明山竹子湖路、 陽金公路、 竹子湖派出所鞍部（ 東北）",
    "備註":null
  },
  {
    "項次": 191,
    "年度": "94/01~95/12",
    "工程種類1": "換表相關",
    "工程種類2": null,
    "工程種類3": null,
    "單位種類1": "政府機構",
    "單位種類2": null,
    "單位種類3": null,
    "主辦單位": "台北自來水事業處",
    "標案名稱": "94~95年南區營業分處抄表作業",
    "標案金額": "10,947,952",
    "地點": "台北市",
    "詳細範圍": "大安、中正、信義、文山、新店\n1. 中山南路以東\n2. 忠孝東路一、 二段、 八德路一段至四段雙號、 信義路五段150巷以南\n3. 基隆路一、 二、 三、 四段以西\n4. 羅斯福路一至四段單號以東及羅斯福路五、 六段\n5. 新店區包括新店溪以東地區（ 安康地區除外）",
    "備註":null
  }
]



// WEBPACK FOOTER //
// ./src/excel.js